export default __webpack_public_path__ + "static/media/gif.1be09601.gif";